module.exports = __webpack_public_path__ + "img/logo-vertical.d1380c77.png";